import * as api from '../../../clients/veranstaltungen';

import {Action} from '@ngrx/store';

export const POST_DOKUMENT_BERECHTIGUNG_HINZUFUEGEN_MULTI = '[VeranstaltungenModul] PostDokumentBerechtigungHinzufuegenMulti laden';
export const POST_DOKUMENT_BERECHTIGUNG_HINZUFUEGEN_MULTI_AUSFUEHREN = '[VeranstaltungenModul] PostDokumentBerechtigungHinzufuegenMulti ausführen';
export const POST_DOKUMENT_BERECHTIGUNG_HINZUFUEGEN_MULTI_ERFOLGREICH = '[VeranstaltungenModul] PostDokumentBerechtigungHinzufuegenMulti laden erfolgreich';
export const POST_DOKUMENT_BERECHTIGUNG_HINZUFUEGEN_MULTI_FEHLER = '[VeranstaltungenModul] PostDokumentBerechtigungHinzufuegenMulti Ladefehler';
export const POST_DOKUMENT_BERECHTIGUNG_HINZUFUEGEN_MULTI_NICHT_AUSGEFUEHRT = '[VeranstaltungenModul] PostDokumentBerechtigungHinzufuegenMulti nicht ausgeführt (evtl. Offline)';


export class PostDokumentBerechtigungHinzufuegenMultiAction implements Action {
    readonly type = POST_DOKUMENT_BERECHTIGUNG_HINZUFUEGEN_MULTI;
        constructor(public dokumentBerechtigungMultiRequest: api.DokumentBerechtigungMultiRequest, public optPayload: any = null) {}
    }
export class PostDokumentBerechtigungHinzufuegenMultiAusfuehrenAction implements Action {
    readonly type = POST_DOKUMENT_BERECHTIGUNG_HINZUFUEGEN_MULTI_AUSFUEHREN;
        constructor(public dokumentBerechtigungMultiRequest: api.DokumentBerechtigungMultiRequest, public optPayload: any = null) {}
    }
export class PostDokumentBerechtigungHinzufuegenMultiErfolgreichAction implements Action {
    readonly type = POST_DOKUMENT_BERECHTIGUNG_HINZUFUEGEN_MULTI_ERFOLGREICH;
        constructor(public payload: api.DokumentIdentifier, public dokumentBerechtigungMultiRequest: api.DokumentBerechtigungMultiRequest, public optPayload: any = null) {}
    }
export class PostDokumentBerechtigungHinzufuegenMultiFehlerAction implements Action {
    readonly type = POST_DOKUMENT_BERECHTIGUNG_HINZUFUEGEN_MULTI_FEHLER;
        constructor(public payload: any, public dokumentBerechtigungMultiRequest: api.DokumentBerechtigungMultiRequest, public optPayload: any = null) {}
    }
export class PostDokumentBerechtigungHinzufuegenMultiNichtAusgefuehrtAction implements Action {
    readonly type = POST_DOKUMENT_BERECHTIGUNG_HINZUFUEGEN_MULTI_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type VeranstaltungenCommandDokumentBerechtigungHinzufuegenMultiActions =
    PostDokumentBerechtigungHinzufuegenMultiAction
    | PostDokumentBerechtigungHinzufuegenMultiAusfuehrenAction
    | PostDokumentBerechtigungHinzufuegenMultiErfolgreichAction
    | PostDokumentBerechtigungHinzufuegenMultiFehlerAction
    | PostDokumentBerechtigungHinzufuegenMultiNichtAusgefuehrtAction
    ;
